import { InjectionToken } from '@angular/core';
import { MenuItem } from 'primeng/api';

export const MAIN_MENU_CHUNK = new InjectionToken<(MenuItem | null)[]>('MainMenuChunk', {
  providedIn: 'root',
  factory: () => [],
});
